import { render, staticRenderFns } from "./Dashboard-Aluno.vue?vue&type=template&id=1e77a8c5&scoped=true&"
import script from "./Dashboard-Aluno.vue?vue&type=script&lang=js&"
export * from "./Dashboard-Aluno.vue?vue&type=script&lang=js&"
import style0 from "../assets/estilo-dashboard.css?vue&type=style&index=0&lang=css&"
import style1 from "../assets/estilo-dashboard-2.css?vue&type=style&index=1&lang=css&"
import style2 from "./Dashboard-Aluno.vue?vue&type=style&index=2&id=1e77a8c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e77a8c5",
  null
  
)

component.options.__file = "Dashboard-Aluno.vue"
export default component.exports